/** FAQ, Support, and Advertising page copy (Dutch translation). */
export const pagesMessagesNl = {
  faq: {
    pageTitle: "Veelgestelde vragen",
    pageSubtitle: "Vind antwoorden op veelgestelde vragen over WasOK",
    seoTitle: "Veelgestelde vragen — WasOK",
    seoDescription:
      "Antwoorden op veelgestelde vragen over WasOK, het scannen van producten, privacy en beoordelingen.",
    items: [
      {
        question: "Hoe werkt WasOK?",
        answer:
          "WasOK helpt je onthouden welke producten je wel of niet lekker vond door barcodes te scannen en je beoordelingen en notities op te slaan. Scan gewoon de barcode van een product, beoordeel het, voeg notities toe, en de volgende keer dat je hetzelfde product scant, zie je direct je eerdere beoordeling.",
      },
      {
        question: "Worden mijn gegevens opgeslagen in de cloud?",
        answer:
          "Nee! Al je gegevens worden lokaal op je apparaat opgeslagen. We synchroniseren je informatie niet met de cloud, wat betekent dat je winkelgeschiedenis en productmeningen volledig privé blijven. Dit betekent echter ook dat je een back-up van je apparaat moet maken als je je gegevens wilt behouden.",
      },
      {
        question: "Heb ik een internetverbinding nodig om WasOK te gebruiken?",
        answer:
          "Nee, WasOK werkt volledig offline. Omdat al je gegevens lokaal op je apparaat worden opgeslagen, kun je producten scannen, beoordelingen toevoegen en je geschiedenis bekijken zonder internetverbinding.",
      },
      {
        question: "Kan ik WasOK voor elk type product gebruiken?",
        answer:
          "Ja! WasOK werkt met elk product dat een barcode heeft. Of het nu gaat om eten, cosmetica, huishoudelijke artikelen, elektronica of iets anders met een barcode, je kunt het scannen en je mening opslaan.",
      },
      {
        question: "Hoe scan ik een barcode?",
        answer:
          "Open gewoon de WasOK-app en tik op de scanknop. Richt je camera op de barcode van het product, en de app zal deze automatisch detecteren en scannen. Zorg ervoor dat de barcode goed belicht en scherp is voor de beste resultaten.",
      },
      {
        question: "Kan ik foto's toevoegen aan mijn productbeoordelingen?",
        answer:
          "Ja! Je kunt foto's toevoegen aan elke productbeoordeling. Dit is vooral handig om verpakkingsdetails, ingrediëntenlijsten of andere visuele informatie te onthouden die je kan helpen herinneren waarom je een product wel of niet lekker vond.",
      },
      {
        question: "Welke informatie kan ik over producten opslaan?",
        answer:
          "Je kunt beoordelingen (1-5 sterren), tekstnotities, foto's, de prijs die je betaalde, waar je het kocht en aangepaste categorieën opslaan. Deze uitgebreide informatie helpt je weloverwogen beslissingen te nemen tijdens het winkelen.",
      },
      {
        question: "Kan ik boodschappenlijsten maken?",
        answer:
          "Ja! Met WasOK kun je boodschappenlijsten maken van producten die je al hebt beoordeeld. Zo onthoud je makkelijk welke producten je geweldig vond en opnieuw wilt kopen.",
      },
      {
        question: "Hoe organiseer ik mijn producten?",
        answer:
          "Je kunt producten organiseren met aangepaste categorieën. Je kunt bijvoorbeeld categorieën maken zoals 'Snacks', 'Koffie', 'Huidverzorging' of 'Schoonmaakproducten'. Zo kun je je beoordelingen eenvoudig op type doorbladeren.",
      },
      {
        question: "Is WasOK gratis te gebruiken?",
        answer:
          "Ja, WasOK is volledig gratis om te downloaden en te gebruiken. Er zijn geen in-app-aankopen, abonnementen of verborgen kosten. Wij geloven dat iedereen toegang moet hebben tot een privémanier om zijn productvoorkeuren te onthouden.",
      },
      {
        question: "Is WasOK toegankelijk?",
        answer:
          "WasOK is ontworpen om bruikbaar te zijn voor zoveel mogelijk mensen. De app bevat toegankelijkheidsfuncties zoals ondersteuning voor schermlezers, schaalbare tekst en een optionele hoogcontrastmodus.",
      },
      {
        question: "Wat gebeurt er als ik de app verwijder?",
        answer:
          "Omdat alle gegevens lokaal op je apparaat worden opgeslagen, worden al je productbeoordelingen, notities en boodschappenlijsten verwijderd als je de app verwijdert. Zorg ervoor dat je je gegevens exporteert als je een back-up wilt bewaren voordat je de app verwijdert.",
      },
      {
        question: "Kan ik mijn gegevens exporteren?",
        answer:
          "Ja, met WasOK kun je je gegevens exporteren voor back-updoeleinden. Je kunt al je beoordelingen exporteren naar een bestand dat je kunt opslaan op je apparaat of in de cloudopslag van je keuze.",
      },
      {
        question: "Volgt WasOK mijn locatie?",
        answer:
          "Nee, WasOK volgt je locatie niet. Hoewel je handmatig de naam van de winkel kunt invoeren waar je een product hebt gekocht, gebruikt de app geen gps of locatieservices.",
      },
      {
        question: "Kan ik WasOK op meerdere apparaten gebruiken?",
        answer:
          "Momenteel synchroniseert WasOK niet tussen apparaten, omdat alle gegevens lokaal worden opgeslagen. Elk apparaat heeft zijn eigen aparte database van producten en beoordelingen.",
      },
      {
        question: "Wat als een barcode niet scant?",
        answer:
          "Als een barcode niet scant, zorg er dan voor dat deze goed belicht en scherp is. Je kunt ook proberen de cameralens schoon te maken. Als de barcode beschadigd of onduidelijk is, kun je mogelijk het barcodenummer handmatig invoeren.",
      },
    ],
    cta: {
      heading: "Nog vragen?",
      body: "Neem contact op met ons supportteam — we helpen je graag.",
      button: "Contact opnemen met support",
    },
  },
  support: {
    pageTitle: "Support",
    seoTitle: "Support — WasOK",
    seoDescription:
      "Krijg hulp met WasOK: neem contact op met support, meld bugs en deel feedback.",
    getHelp: {
      title: "Hulp krijgen",
      body: "We staan klaar om je te helpen het meeste uit WasOK te halen. Als je problemen ondervindt of vragen hebt, hebben we verschillende bronnen beschikbaar om je te helpen.",
    },
    faq: {
      title: "Veelgestelde vragen",
      body: "Voordat je contact opneemt, bekijk onze FAQ-sectie waar we de meest gestelde vragen over WasOK beantwoorden. Je vindt er gedetailleerde informatie over hoe de app werkt, privacy, gegevensopslag en meer.",
    },
    contact: {
      title: "Contact opnemen met support",
      body: "Als je het antwoord dat je zoekt niet kunt vinden, staat ons supportteam klaar om te helpen. Je kunt ons bereiken via:",
      emailLabel: "E-mail:",
      responseTime: "We reageren doorgaans binnen 24-48 uur",
    },
    bugs: {
      title: "Bugs melden",
      body: "Een bug gevonden? We stellen je hulp om WasOK beter te maken zeer op prijs. Vermeld bij het melden van een bug het volgende:",
      items: [
        "Een gedetailleerde beschrijving van het probleem",
        "Stappen om het probleem te reproduceren",
        "Je apparaatmodel en Android-versie",
        "Screenshots of schermopnames indien mogelijk",
      ],
      sendPrefix: "Stuur bugmeldingen naar:",
    },
    featureRequests: {
      title: "Functieverzoeken",
      bodyBefore: "Heb je een idee voor een nieuwe functie? We horen het graag! Stuur je suggesties naar",
      bodyAfter:
        ". Hoewel we niet elk verzoek kunnen implementeren, overwegen we alle feedback zorgvuldig bij het plannen van toekomstige updates.",
    },
    knownIssues: {
      title: "Bekende problemen",
      body: "We zijn ons momenteel bewust van de volgende problemen en werken aan oplossingen:",
      items: [
        "Sommige barcodes worden mogelijk niet gescand bij weinig licht — probeer een zaklamp te gebruiken",
        "Zeer lange productnotities kunnen even duren om op te slaan op oudere apparaten",
        "Miniaturen van afbeeldingen kunnen er gepixeld uitzien op schermen met hoge resolutie",
      ],
    },
    appUpdates: {
      title: "App-updates",
      body: "We brengen regelmatig updates uit met nieuwe functies, verbeteringen en bugfixes. Zorg ervoor dat je WasOK up-to-date houdt via de Google Play Store om de nieuwste verbeteringen te krijgen.",
    },
    community: {
      title: "Community",
      body: "Sluit je aan bij onze community van gebruikers die slimmere winkelbeslissingen nemen met WasOK. Deel tips, stel vragen en maak contact met andere gebruikers op onze sociale kanalen.",
    },
    emergency: {
      title: "Noodondersteuning",
      body: 'Als je een kritiek probleem ondervindt waardoor je de app niet kunt gebruiken, markeer je e-mail dan als "URGENT" in het onderwerp, en we zullen je verzoek met prioriteit behandelen.',
    },
    cta: {
      heading: "Nog steeds hulp nodig?",
      body: "Ons supportteam staat voor je klaar. Aarzel niet om contact op te nemen met vragen of zorgen.",
      button: "E-mail support",
    },
  },
  advertising: {
    pageTitle: "Advertenties & monetisatie",
    seoTitle: "Advertenties — WasOK",
    seoDescription: "Hoe WasOK omgaat met advertenties en monetisatie.",
    approach: {
      title: "Onze aanpak",
      body: "Bij WasOK geloven we dat je winkelgewoontes en productmeningen privé en persoonlijk zijn. Ons verdienmodel weerspiegelt deze kernwaarde.",
    },
    noAds: {
      title: "Geen advertenties",
      body: "WasOK toont geen enkele advertentie. We zullen je nooit advertenties tonen op basis van de producten die je scant, de beoordelingen die je geeft, of andere gegevens die je in de app creëert. Je ervaring met WasOK is volledig advertentievrij.",
    },
    noDataSelling: {
      title: "Geen gegevensverkoop",
      body: "We verkopen, verhuren of delen je gegevens niet met adverteerders, databrokers of derden. Omdat al je gegevens lokaal op je apparaat worden opgeslagen, hebben wij er zelfs geen toegang toe. Je productbeoordelingen, boodschappenlijsten en notities zijn van jou alleen.",
    },
    noTracking: {
      title: "Geen tracking",
      body: "WasOK gebruikt geen trackingpixels, analysediensten of andere technologie die je gedrag volgt of informatie deelt met derden. We volgen niet welke producten je scant, in welke winkels je koopt of hoe je de app gebruikt.",
    },
    sustainability: {
      title: "Hoe we duurzaam blijven",
      body: "Je vraagt je misschien af hoe we WasOK gratis houden zonder advertenties of gegevensverkoop. Onze aanpak is eenvoudig:",
      items: [
        {
          label: "Gratis en open:",
          text: "WasOK is gratis voor iedereen om te gebruiken, zonder premium niveaus of paywalls",
        },
        {
          label: "Efficiënte werking:",
          text: "We houden onze kosten laag door efficiënte, privacygerichte software te bouwen",
        },
        {
          label: "Optionele donaties:",
          text: "Gebruikers die van WasOK houden, kunnen ons steunen via vrijwillige donaties",
        },
        {
          label: "Open source:",
          text: "We bieden mogelijk consultancy of maatwerk ontwikkelservices aan voor organisaties",
        },
      ],
    },
    noAffiliate: {
      title: "Geen affiliatelinks",
      body: "WasOK gebruikt geen affiliatelinks en ontvangt geen commissies van winkels. Wanneer je een product scant, sturen we je nergens naartoe om het te kopen. De app is puur bedoeld voor je persoonlijke administratie en besluitvorming.",
    },
    noPromotions: {
      title: "Geen productpromoties",
      body: "We accepteren geen betaling van merken of fabrikanten om hun producten te promoten. WasOK zal nooit producten voorstellen, bepaalde merken uitlichten of je beoordelingen op enige manier beïnvloeden. Je meningen zijn van jou alleen.",
    },
    partnerships: {
      title: "Partnerschappen met derden",
      body: "WasOK werkt niet samen met marketingbedrijven, gegevensaggregators of advertentienetwerken. We opereren onafhankelijk en stellen je privacy boven alles.",
    },
    future: {
      title: "Toekomstplannen",
      body: "We zetten ons in om WasOK advertentievrij en privacygericht te houden. Als we ooit in de toekomst een duurzaam verdienmodel moeten introduceren, zullen we:",
      items: [
        "Eventuele wijzigingen ruim van tevoren aankondigen",
        "Nooit inleveren op privacy of gegevensbeveiliging",
        "Altijd een manier bieden om de app te gebruiken zonder tracking of advertenties",
        "Luisteren naar feedback en zorgen van gebruikers",
      ],
    },
    supporting: {
      title: "WasOK steunen",
      body: "Als je van WasOK houdt en onze missie van privacygerichte winkelherinneringen wilt steunen, kun je:",
      items: [
        "Je vrienden en familie over de app vertellen",
        "Een positieve beoordeling achterlaten op de Google Play Store",
        "Je feedback en suggesties met ons delen",
        "Overwegen een vrijwillige donatie te doen (indien beschikbaar)",
      ],
    },
    cta: {
      heading: "Vragen over ons beleid?",
      body: "We zijn transparant over hoe WasOK werkt. Als je vragen hebt over onze aanpak van privacy, monetisatie of duurzaamheid, neem dan contact op.",
      button: "Neem contact op",
    },
  },
};
